import { AbstractModel, TimeUtil } from '@uzurv/core';
import { autoserialize, inheritSerialization } from 'cerialize';

@inheritSerialization(AbstractModel)
export class FareCalculation extends AbstractModel {
  @autoserialize
  reservationId: number;

  @autoserialize
  fareReviewStatusId: number;

  @autoserialize
  active: boolean;

  @autoserialize
  estimate: boolean;

  @autoserialize
  adjustedByUserId: number;

  @autoserialize
  reviewedByUserId: number;

  @autoserialize
  distanceMiles: number;

  @autoserialize
  durationSeconds: number;

  @autoserialize
  distanceRate: number;

  @autoserialize
  timeRate: number;

  @autoserialize
  minimumFare: number;

  @autoserialize
  riderFeeBaseDistance: number;

  @autoserialize
  riderFeeDistanceRate: number;

  @autoserialize
  additionalPassengerFee: number;

  @autoserialize
  taxPercent: number;

  @autoserialize
  baseFare: number;

  @autoserialize
  timeFare: number;

  @autoserialize
  distanceFare: number;

  @autoserialize
  grossFare: number;

  @autoserialize
  bookingFee: number;

  @autoserialize
  platformFee: number;

  @autoserialize
  mileageSurcharge: number;

  @autoserialize
  additionalPassengerSurcharge: number;

  @autoserialize
  baseRiderFee: number;

  @autoserialize
  flatTax: number;

  @autoserialize
  rateTax: number;

  @autoserialize
  totalFare: number;

  @autoserialize
  totalRiderFee: number;

  @autoserialize
  invoiceAmount: number;

  @autoserialize
  providerDistanceRate: number;

  @autoserialize
  providerTimeRate: number;

  @autoserialize
  providerBaseFare: number;

  @autoserialize
  providerDistanceFare: number;

  @autoserialize
  providerTimeFare: number;

  @autoserialize
  providerIncentive: number;

  @autoserialize
  providerTollReimbursement: number;

  @autoserialize
  providerLoadFee: number;

  @autoserialize
  providerLoadFeeBaseDistance: number;

  @autoserialize
  providerMileageRate: number;

  @autoserialize
  providerMileageFee: number;

  @autoserialize
	fuelSurchargeRate: number;

	@autoserialize
	fuelSurcharge: number;

	@autoserialize
	providerFuelSurchargeRate: number;

	@autoserialize
	providerFuelSurcharge: number;

  @autoserialize
  providerInvoiceAmount: number;

  @autoserialize
  polylineId: number;

  get durationInMinutes() {
    return Math.trunc(TimeUtil.convertSecondsToMinutes(this.durationSeconds));
  }
}
